__turbopack_context__.v({
  "content": "minimal-header-module-scss-module__7G08oa__content",
  "contentBorder": "minimal-header-module-scss-module__7G08oa__contentBorder",
  "description": "minimal-header-module-scss-module__7G08oa__description",
  "header": "minimal-header-module-scss-module__7G08oa__header",
  "heading": "minimal-header-module-scss-module__7G08oa__heading",
  "headingContainer": "minimal-header-module-scss-module__7G08oa__headingContainer",
  "languageFilterContainer": "minimal-header-module-scss-module__7G08oa__languageFilterContainer",
  "linkItem": "minimal-header-module-scss-module__7G08oa__linkItem",
  "linkList": "minimal-header-module-scss-module__7G08oa__linkList",
});
